import React, { useState, useContext, useRef, useEffect } from "react";
import { AuthContext } from '../../comum/Context/auth';
import './index.css';
import { api } from '../../services/api';
import logoSmall from './../../comum/assets/arbor.png';
import { Link, useNavigate } from 'react-router-dom'; 
import { setLoginToday } from "./../../app/Utils/auth.js";

import firebase from '../Config/firebase';
import 'firebase/compat/auth';

import Menu from '../../comum/Menu/menu.jsx';
import Footer from '../../comum/Footer';

function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [sucesso, setSucesso] = useState(false);
  const inputRef = useRef(null);
  const [eyesIsClosed, setEyeState] = useState(false);  
  const { setLogado } = useContext(AuthContext);

  const toggleShow = () => {
    if (inputRef.current.type === "password") {
      setEyeState(true);
      inputRef.current.type = "text";
    } else {
      setEyeState(false);
      inputRef.current.type = "password";
    }
  };

  function LoginUsuario() {
    firebase.auth().signInWithEmailAndPassword(email, senha)
      .then(() => {
        PesquisarRestaurante();
      })
      .catch(() => {
        setErro('E-mail ou senha inválidos.');
      });
  }

  function PesquisarRestaurante() {
    api.get('/restaurante/cadastro/' + email)
      .then((retorno) => {
        const codigoRest = retorno.data[0]?.codigo;
        if (codigoRest) {
          setLoginToday(null, null, null, codigoRest); // salva no localStorage
          //setLoginToday(null, null, null, '2032666');
          localStorage.removeItem("chapa");
          setLogado(true);
          setSucesso(true); // aguarda esse estado para navegar
        } else {
          setErro('Esse e-mail não está associado a um restaurante.');
        }
      })
      .catch(() => {
        setErro('Esse e-mail não está associado a um restaurante.');
      });
  }

  // Quando sucesso for true, redireciona
  useEffect(() => {
    if (sucesso) {
      navigate('/restaurante/pedido'); // sem o código na URL
    }
  }, [sucesso]);

  return (  
    <div>
      <Menu />
      <div className="d-flex align-items-center text-center form-container">      
        <form className="form-signin">
          <img className="mb-4 img-logo" src={logoSmall} alt="" />
          <h1 className="h3 mb-3 fw-normal">Login</h1>
          
          <div className="form-floating">
            <input 
              onChange={(e) => setEmail(e.target.value)} 
              type="email" 
              className="form-control" 
              placeholder="E-mail" 
            />
            <label>E-mail</label>
          </div>

          <div className="form-floating">
            <input 
              onChange={(e) => setSenha(e.target.value)} 
              ref={inputRef} 
              type="password" 
              className="form-control" 
              placeholder="Senha" 
            />
            <label>Senha</label>
          </div>

          <button onClick={LoginUsuario} className="w-100 btn btn-lg btn-success" type="button">
            Acessar
          </button>

          {erro && <div className="alert alert-danger mt-2" role="alert">{erro}</div>}

          <div className="login-links mt-5">
            <Link to="/restaurante/resetsenha" className="mx-3 font-link">Esqueci minha senha</Link>
            <Link to="/restaurante/novaconta" className="mx-3 font-link">Criar uma conta</Link>
          </div>

          <p className="mt-5 mb-3 text-muted">&copy; Desenvolvido por F2 Enterprise</p>
        </form>
      </div>
      <Footer />
    </div>
  );
}

export default Login;
